import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CatalogDetailPage } from '@/features/data/catalog/catalog-detail-page';
import { catalogSearch } from '@/features/data/catalog/catalog-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Un champ : feuille de l'arbre, résumé et définition. */
export const Route = createFileRoute('/$tenant/catalog/$layer/$database/$table/$field')({
  validateSearch: catalogSearch,
  component: FieldRoute,
});

function FieldRoute() {
  const { tenant, layer, database, table, field } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="catalog"
      crumbs={[
        { label: t('nav.items.catalog') },
        { label: layer, mono: true },
        { label: database, mono: true },
        { label: table, mono: true },
        { label: field, mono: true },
      ]}
    >
      <CatalogDetailPage
        tenantId={tenant}
        path={{ level: 'field', layer, database, table, field }}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
